module.exports = __webpack_public_path__ + "static/media/merchant_bg.9b7b62ba.jpg";